import React from "react";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "mdi-react/CloseIcon";
import { useFormik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  comment: Yup.string()
    .required("Comment is required")
    .trim(),
});

export default function PointOfSaleCommentModal({
  show,
  onHide,
  onSubmit,
  posComment,
  setActivePOSItem,
}) {
  const formik = useFormik({
    initialValues: {
      comment: posComment || "",
    },
    validationSchema,
    onSubmit: (values) => {
      if (onSubmit) {
        onSubmit(values.comment);
      }
      formik.resetForm();
      setActivePOSItem({});
    },
    enableReinitialize: true,
  });

  return (
    <Modal
      show={show}
      onHide={() => {
        setActivePOSItem({});
        onHide(false);
      }}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div>
          <div className="d-flex justify-content-between">
            <h4 className="h4">{posComment ? "Edit " : "Add "}Comment</h4>
            <div
              role="button"
              aria-label="button"
              className="text-lg"
              onClick={() => {
                setActivePOSItem({});

                onHide(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <p className="text-muted">
            {posComment ? "Update " : "Add "} comment for this item
          </p>

          <div className="mt-3">
            <textarea
              className={`form-control ${
                formik.touched.comment && formik.errors.comment
                  ? "is-invalid"
                  : ""
              }`}
              rows="4"
              placeholder="Enter your comment here"
              name="comment"
              value={formik.values.comment}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.comment && formik.errors.comment && (
              <div className="invalid-feedback d-block">
                {formik.errors.comment}
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
      <div className="d-inline-flex justify-content-end m-4">
        <button className="btn bg print mx-2" onClick={() => onHide(false)}>
          Cancel
        </button>
        <button
          className="btn btn-primary text-white"
          onClick={formik.handleSubmit}
          disabled={!formik.values.comment.trim() || formik.isSubmitting}
        >
          Submit
        </button>
      </div>
    </Modal>
  );
}
